var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.716,
    className: "more",
    height: 16.724,
    viewBox: "0 0 3.716 16.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".more .a{fill:#acb5c0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-149.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.333 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.858,
    cy: 1.858,
    r: 1.858
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.333 6.504)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.858,
    cy: 1.858,
    r: 1.858
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.333 13.007)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 1.858,
    cy: 1.858,
    r: 1.858
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.f1c43f80373899784a02198cd2e4ecc8.svg";
export { ForwardRef as ReactComponent };